import axios from "axios";
import Constants from "../config/constants";
import store from "../store";
import { actionLogoutUser, actionUpdateToken } from "../actions/Auth.action";
import { serviceUpdateUserToken } from "../services/index.services";
import { setAuthorizationToken } from "../libs/set_auth_token.utils";

export async function handle403AndRetry(originalRequestFn) {
  try {
    const userStr = localStorage.getItem("user");
    const userObj = userStr ? JSON.parse(userStr) : null;
    const refreshToken = userObj?.refresh_token;

    if (!refreshToken) {
      store.dispatch(actionLogoutUser());
      return { error: true, authorization: false };
    }

    // Call refresh token API
    const refreshRes = await serviceUpdateUserToken({ refresh_token: refreshToken });

    // If refresh API itself throws 401 → Logout
    if (refreshRes?.authorization === false) {
      store.dispatch(actionLogoutUser());
      return { error: true, authorization: false };
    }

    // If refresh successful → update tokens
    if (!refreshRes.error && refreshRes.data?.token) {
      const { token, refresh_token: newRefreshToken } = refreshRes.data;

      localStorage.setItem("jwt_token", token);
      if (userObj) {
        userObj.token = token;
        if (newRefreshToken) userObj.refresh_token = newRefreshToken;
        localStorage.setItem("user", JSON.stringify(userObj));
      }

      setAuthorizationToken(token);
      store.dispatch(actionUpdateToken({ token }));
      return await originalRequestFn();
    }

    store.dispatch(actionLogoutUser());
    return { error: true, authorization: false };

  } catch (err) {
    store.dispatch(actionLogoutUser());
    return { error: true, authorization: false };
  }
}

export async function postRequest(url, params) {
  try {
    const tempRequest = await axios.post(`${Constants.DEFAULT_APP_URL}${url}`, {
      ...params,
    });
    if (tempRequest.status === 200) {

      if (tempRequest.data.response_code === 1) {
        return {
          error: false,
          message: "",
          data: tempRequest.data.response_obj,
          authorization: true,
          response_code: tempRequest.data.response_code,
        };
      }
      return {
        error: true,
        message: tempRequest.data.response_message,
        authorization: true,
        response_code: tempRequest.data.response_code,
      };
    }
  } catch (err) {
    if (err?.response?.status === 401) {
      store.dispatch(actionLogoutUser());
      return { error: true, authorization: false, response_code: 0 };
    }
    if (err?.response?.status === 403) {
      return handle403AndRetry(() => postRequest(url, params));
    }
    return {
      error: true,
      message: Constants.API_ERROR_OBJ[err?.response?.status]
        ? `${Constants.API_ERROR_OBJ[err.response.status]}`
        : "Something Went Wrong",
      authorization: true,
    };
  }
}

export async function getRequest(url, params) {
  try {
    const tempRequest = await axios.get(`${Constants.DEFAULT_APP_URL}${url}`, {
      params: { ...params },
    });
    if (tempRequest.status === 200) {
    
      if (tempRequest.data.response_code === 1) {
        return {
          error: false,
          message: "",
          data: tempRequest.data.response_obj,
          authorization: true,
        };
      }
      return {
        error: true,
        message: tempRequest.data.response_message,
        authorization: true,
      };
    }
  } catch (err) {
    if (err?.response?.status === 401) {
      return { error: true, authorization: false };
    }
    if (err?.response?.status === 403) {
      return handle403AndRetry(() => getRequest(url, params));
    }
    return {
      error: true,
      message: Constants.API_ERROR_OBJ[err?.response?.status]
        ? `${Constants.API_ERROR_OBJ[err.response.status]}`
        : "Something Went Wrong",
      authorization: true,
    };
  }
}

// ===== FormData Request =====
export async function formDataRequest(url, formData) {
 
  try {
    const tempRequest = await axios({
      method: "post",
      url: `${Constants.DEFAULT_APP_URL}${url}`,
      data: formData,
      config: { headers: { "Content-Type": "multipart/form-data" } },
    });
    if (tempRequest.status === 200) {
      if (tempRequest.data.response_code === 1) {
        return {
          error: false,
          message: "",
          data: tempRequest.data.response_obj,
          authorization: true,
        };
      }
      return {
        error: true,
        message: tempRequest.data.response_message,
        authorization: true,
      };
    }
  } catch (err) {
    if (err?.response?.status === 401) {
      return { error: true, authorization: false };
    }
    if (err?.response?.status === 403) {
      return handle403AndRetry(() => formDataRequest(url, formData));
    }
    return {
      error: true,
      message: Constants.API_ERROR_OBJ[err?.response?.status]
        ? `${Constants.API_ERROR_OBJ[err.response.status]}`
        : "Something Went Wrong",
      authorization: true,
    };
  }
}
